import { z } from 'zod';
import { MIN_VEHICLE_YEAR, maxVehicleYear } from '../constants.js';
import { emailSchema, nonEmptyTrimmed, optionalTrimmed, paginated, uuidSchema } from './common.js';
export const createCustomerSchema = z.object({
    fullName: nonEmptyTrimmed(120),
    email: emailSchema.optional(),
    phone: optionalTrimmed(30),
    notes: optionalTrimmed(2000),
});
export const updateCustomerSchema = createCustomerSchema.partial();
export const customerListItemSchema = z.object({
    id: uuidSchema,
    fullName: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    vehicleCount: z.number().int(),
    totalSpentCents: z.number().int(),
    createdAt: z.string(),
});
export const customerListResponseSchema = paginated(customerListItemSchema);
export const customerDetailSchema = customerListItemSchema.extend({
    notes: z.string(),
    quotesCount: z.number().int(),
    jobsCount: z.number().int(),
});
// ---- Vehicles ----
const VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;
export const createVehicleSchema = z.object({
    year: z.number().int().min(MIN_VEHICLE_YEAR).refine((y) => y <= maxVehicleYear(), { message: 'Enter a valid model year' }).optional(),
    make: optionalTrimmed(60),
    model: optionalTrimmed(60),
    trim: optionalTrimmed(60),
    color: optionalTrimmed(60),
    vin: z.string().trim().toUpperCase().regex(VIN_RE, 'VIN must be 17 characters (no I, O, or Q).').optional().or(z.literal('')),
    notes: optionalTrimmed(2000),
});
export const updateVehicleSchema = createVehicleSchema.partial();
export const vehicleSchema = z.object({
    id: uuidSchema,
    customerId: uuidSchema,
    year: z.number().int().nullable(),
    make: z.string(),
    model: z.string(),
    trim: z.string(),
    color: z.string(),
    vinMasked: z.string().nullable(),
    notes: z.string(),
    photos: z.array(z.object({ id: uuidSchema, url: z.string(), thumbUrl: z.string().nullable() })),
    createdAt: z.string(),
});
export const vinRevealResponseSchema = z.object({ vin: z.string() });
//# sourceMappingURL=customers.js.map